import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import {
  Card,
  CardHeader,
  TableCard
} from 'components/content-containers/cards';
import { EditButton, SVGButton } from 'components/widgets/buttons';
import {
  MetadataItem,
  MetadataTable,
  Table
} from 'components/content-containers/tables';
import { PageContent } from 'components/page';
import { ShortDate } from 'components/widgets/dates';
import { getFileOpenUrl, getFormUrl, getFormUrlAbsolute } from 'utils/google-drive-utils';
import CompanyLink from 'components/models/company/company-link';
import CopyToClipboard from 'components/widgets/icons/copy-to-clipboard';
import SVG from 'components/widgets/icons/svg';

import * as actions from '../store/actions';

export default function CompanyFormResponses({ routeParams: { formId }, id: companyId }) {
  const { data: company } = actions.useCompany(companyId);
  const { data: forms } = actions.useCompanyForms(companyId);
  const form = _.find(forms, { id: Number(formId) });

  if (!form) return null;

  const link = getFormUrl(form.form.fileId);
  const linkAbsolute = getFormUrlAbsolute(form.form.fileId);
  const isDefaultForm = form.title === 'Onboarding' || form.title === 'Offboarding';

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="flex flex-equal-children">
        <Card>
          <CardHeader className="light">
            <Link to={`/companies/${company.id}/forms`}>
              <SVG src="svg/chevron-left.svg" />
              Back to all {company.nickname} forms
            </Link>
          </CardHeader>
          <div className="summary-wrapper">
            <div className="card-icon-buttons">
              { !isDefaultForm && <Link to={`/companies/${company.id}/forms/${form.id}/edit`}><EditButton title="Edit details" /></Link> }
              <a target="_blank" href={getFileOpenUrl(form.form.fileId)}>
                <SVGButton src="svg/cog.svg" title="Edit Google form" />
              </a>
            </div>
            <MetadataTable>
              <MetadataItem label="Form">{form.title}</MetadataItem>
              <MetadataItem label="Company"><CompanyLink company={company} /></MetadataItem>
              <MetadataItem label="Link">
                <a target="_blank" href={link} className="margin-right">Form Link</a>
                <CopyToClipboard component="span" copyText={linkAbsolute} tooltip="Copy form url">
                  <SVG src="svg/clipboard.svg" className="clipboard" />
                </CopyToClipboard>
              </MetadataItem>
            </MetadataTable>
          </div>
        </Card>
        <TableCard>
          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Requestor</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {_.map(form.responses.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)), (response, index) => {
                const map = _.keyBy(response.responses, 'key');

                return (
                  <tr key={index}>
                    <td className="collapse-width"><a target="_blank" href={response.url}><ShortDate date={response.timestamp} /></a></td>
                    <td>{_.get(map, '[Your name].value')}</td>
                    <td>{_.get(map, '[User full name].value')}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </TableCard>
      </div>
    </PageContent>
  );
}



// WEBPACK FOOTER //
// ./app/routes/company/sub-routes/form-responses.js